import { graphql } from "gatsby"
import React from "react"

import Layout from "../../Layout"
import OnlyWithProfile from "../../QueryUserProfile/OnlyWithProfile"
import OnlyForGuest from "../../registration/OnlyForGuest"
import OnlyForUser from "../../registration/OnlyForUser"
import SEO from "../../seo"
import { iPageContext } from "../../types"
import ArticlePage from "./ArticlePage"

export const query = graphql`
  query PageQuery($article_id: String, $topic_id: String) {
    topic: topicsYaml(id: { eq: $topic_id }) {
      slug: path
      title
    }

    data: articlesYaml(id: { eq: $article_id }) {
      discoverable
      thumbnail {
        childImageSharp {
          fluid(maxWidth: 1440) {
            aspectRatio
            base64
            sizes
            src
            srcSet
          }
        }
      }
      description: excerpt
      content {
        bullets {
          default
          translations {
            content
            language
          }
        }

        heading {
          default
          translations {
            content
            language
          }
        }
        paragraph {
          default
          translations {
            content
            language
          }
        }
        title {
          default
          translations {
            content
            language
          }
        }
      }
      last_updated_at
      slug: path
      read_time
      related_videos {
        link
        title
      }
      related_articles {
        articles
        lifestyle
      }
      previous_articles
      next_articles

      title
      useful_links {
        link
        title
      }
    }
  }
`

export default (props: any) => {
  const pageContext: iPageContext = {
    data: props.data.data,
    topic: props.data.topic,
    related_articles: props.pageContext.related_articles,
    previous_articles: props.pageContext.previous_articles,
    next_articles: props.pageContext.next_articles,
  }

  return (
    <Layout pageTitle={"Article"}>
      <SEO
        title={pageContext.data.title}
        description={pageContext.data.description}
      />

      <OnlyForUser redirectTo={null}>
        <OnlyWithProfile
          childrenWithProfileData={userProfile => (
            <ArticlePage
              pageContext={pageContext}
              userProfile={
                userProfile && userProfile.length ? userProfile[0] : null
              }
            />
          )}
        />
      </OnlyForUser>
      <OnlyForGuest redirectTo={null}>
        <ArticlePage pageContext={pageContext} userProfile={null} />
      </OnlyForGuest>
    </Layout>
  )
}
